var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 25.5,
    height: 25.5,
    rx: 4.75,
    stroke: "#9E9E9E",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9927 10.8464L14.7411 17.3078M11.2589 17.3078L11.0073 10.8464M18.2567 8.54184C18.5055 8.57918 18.7527 8.61866 19 8.66102M18.2567 8.54184L17.48 18.5089C17.4483 18.9147 17.2626 19.2937 16.96 19.5701C16.6574 19.8466 16.2603 20.0001 15.848 20H10.152C9.73971 20.0001 9.34256 19.8466 9.03999 19.5701C8.73741 19.2937 8.5517 18.9147 8.52 18.5089L7.74327 8.54184M18.2567 8.54184C17.4174 8.41658 16.5736 8.32151 15.7273 8.25683M7.74327 8.54184C7.49455 8.57846 7.24727 8.61795 7 8.6603M7.74327 8.54184C8.58264 8.41658 9.42635 8.32151 10.2727 8.25683M15.7273 8.25683V7.5992C15.7273 6.75205 15.0655 6.0456 14.2073 6.01904C13.4026 5.99365 12.5974 5.99365 11.7927 6.01904C10.9345 6.0456 10.2727 6.75276 10.2727 7.5992V8.25683M15.7273 8.25683C13.9118 8.11832 12.0882 8.11832 10.2727 8.25683",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGray);
export default __webpack_public_path__ + "static/media/delete-gray.5d896a76fc2f93ebc9924de570fb78a4.svg";
export { ForwardRef as ReactComponent };